import {
  GET_ADMINPORTALALERT_REQUESTED,
  GET_ADMINPORTALALERT_COMPLETED,
  GET_ADMINPORTALALERT_FAILED,
  SET_ADMINPORTALALERT_REQUESTED,
  SET_ADMINPORTALALERT_COMPLETED,
  SET_ADMINPORTALALERT_FAILED,
} from '../../actions/adminportalalert/types';
import { Action } from '../../utils/redux';

type ReducerActions =
  | Action<typeof GET_ADMINPORTALALERT_REQUESTED>
  | Action<
      typeof GET_ADMINPORTALALERT_COMPLETED,
      {
        Message: string;
        Mode: string;
      }
    >
  | Action<typeof GET_ADMINPORTALALERT_FAILED, Error>
  | Action<typeof SET_ADMINPORTALALERT_REQUESTED>
  | Action<typeof SET_ADMINPORTALALERT_COMPLETED>
  | Action<typeof SET_ADMINPORTALALERT_FAILED>;

export interface AdminPortalAlertState {
  error: null | Error;
  data: null | {
    Message: string;
    Mode: string;
  };
  gettingdata: boolean;
  settingdata: boolean;
  gotdata: boolean;
  setdata: boolean;
}

export const initialState: AdminPortalAlertState = {
  error: null,
  data: null,
  gettingdata: false,
  settingdata: false,
  gotdata: false,
  setdata: false,
};

function reducer(state = initialState, action: ReducerActions) {
  switch (action.type) {
    case GET_ADMINPORTALALERT_REQUESTED:
      return {
        ...state,
        error: null,
        data: null,
        gettingdata: true,
      };

    case GET_ADMINPORTALALERT_COMPLETED:
      return {
        ...state,
        error: null,
        gettingdata: false,
        gotdata: true,
        data: action.payload,
      };

    case GET_ADMINPORTALALERT_FAILED:
      return {
        ...state,
        error: action.payload,
      };

    case SET_ADMINPORTALALERT_REQUESTED:
      return {
        ...state,
        error: null,
        data: null,
        settingdata: true,
      };

    case SET_ADMINPORTALALERT_COMPLETED:
      return {
        ...state,
        error: null,
        settingdata: false,
        setdata: true,
        data: action.payload,
      };

    case SET_ADMINPORTALALERT_FAILED:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
}

export default reducer;
